<template>
  <section class="delete_account_s">
    <div class="delete_account_s_in">
      <div class="delete_account_col">
        <div class="contact-img">
          <img src="/img/contact-img.svg" alt="" />
        </div>
      </div>
      <div class="delete_account_col">
        <form @submit.prevent="onSubmit()">
          <input type="hidden" name="_token" value="#" autocomplete="off" />
          <div class="section-title text-start">
            <h2>Delete My Account</h2>
            <p>
              In the event you delete your account, you will lose all the survey information stored on this device. To submit more questionnaires, you will need to request a new account and activation from PAN UK.
            </p>
          </div>
          <div class="delete_account_row">
            <div class="delete_account_fgr">
              <!-- <label for="name">Your Name</label> -->
              <input
                type="text"
                class="form__field"
                :class="{ 'border border-danger': $v.email.$error }"
                v-model.trim="$v.email.$model"
              />
              <div
                class="text-danger"
                v-if="$v.$anyDirty && !$v.email.required"
              >
                Field is required
              </div>
              <div class="text-danger" v-if="$v.$anyDirty && !$v.email.email">
                Invalid Email
              </div>
            </div>
            <div class="delete_account_fgr">
              <div class="form-check pb-0">
                <input
                  required=""
                  class="form-check-input h-auto p-2"
                  type="checkbox"
                  id="conform"
                  value="1"
                  name="is_agree"
                />
                <label class="form-check-label ps-1" for="conform">
                  I agree PAN UK terms and policy.
                </label>
              </div>
            </div>
          </div>
          <div class="delete_account_fgr delete_account_btn">
            <button type="submit">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </section>
</template>


<script>
import { required, minLength, email } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  name: "Delete Account",
  mixins: [validationMixin],
  data() {
    return {
      email: "",
    };
  },
  validations: {
    email: { required, email },
  },

  computed: {
    ...mapGetters(["getAuthUser"]),
  },
  methods: {
    ...mapMutations(["setUser", "logout"]),
    ...mapActions(["deleteAccount"]),
    onSubmit() {
      console.log("this.email", this.email);
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const user = {
          email: this.email,
        };
        this.deleteAccount(user);
      }
    },
  },
};
</script>

<style type="text/css">
.delete_account_s_in {
  display: flex;
  align-items: center;
}
.delete_account_fgr {
  margin-bottom: 20px;
}
.delete_account_col {
  width: 50%;
  padding: 0 10px;
}
.delete_account_s {
  max-width: 1140px;
  padding: 30px;
  margin: 0 auto;
}
.delete_account_btn button {
  background: #f08112;
  border: 1px solid #f08112;
  color: #fff;
  width: 100%;
  padding: 12px;
  font-size: 15px;
  cursor: pointer;
  border-radius: 5px;
}
.delete_account_btn button:hover {
  background: #fff;
  color: #f08112;
}
.delete_account_fgr input {
  border: 1px solid #d2d2d2;
  border-radius: 5px;
  min-height: 45px;
}
.delete_account_fgr input:focus,
.delete_account_fgr input:focus-visible {
  border: 1px solid #f08112 !important;
  outline: 0;
}
.delete_account_fgr input[type="checkbox"] {
  height: auto;
  min-height: unset;
}
.contact-img img {
  width: 100%;
}
@media (max-width: 767px) {
  .delete_account_s_in {
    flex-wrap: wrap;
  }
  .delete_account_col {
    width: 100%;
    padding: 0;
  }
  .delete_account_col .contact-img {
    margin-bottom: 20px;
  }
}
</style>
